import { KNOWN_ORGS, getOrgIdBySubdomain, getOrgIdByDomain } from '../config/organizations'

// Detect subdomain and redirect to appropriate customer page
export const handleSubdomainRedirect = () => {
  const hostname = window.location.hostname
  const pathname = window.location.pathname

  // app.aifacilitymanager.com should redirect to /login (portal entry point)
  if (hostname === 'app.aifacilitymanager.com' && (pathname === '/' || pathname === '')) {
    window.location.pathname = '/login'
    return
  }

  // Check if we're on a subdomain (not main domain)
  const parts = hostname.split('.')
  let isCustomerSubdomain = false

  // Check for custom domains (marketing sites)
  const isMainDomain = hostname === 'aifacilitymanager.com' ||
                       hostname === 'www.aifacilitymanager.com' ||
                       hostname === 'app.aifacilitymanager.com'

  // Check for subdomain pattern: subdomain.aifacilitymanager.com
  // BUT exclude main domains (app, www) from being treated as customer subdomains
  if (parts.length > 2 && hostname.includes('aifacilitymanager') && !isMainDomain) {
    isCustomerSubdomain = true
  }
  
  // If not on main domain and not localhost, assume it's a customer domain
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')
  
  // Check if this is a local dev subdomain (like atn.localhost)
  const isLocalDevSubdomain = hostname.endsWith('.localhost')

  // Local dev subdomains should be treated as customer subdomains
  if (isLocalDevSubdomain) {
    isCustomerSubdomain = true
  }

  if (!isMainDomain && !isLocalhost && !isLocalDevSubdomain) {
    isCustomerSubdomain = true
  }
  
  // If on customer subdomain but not on customer route, redirect
  if (isCustomerSubdomain && !pathname.startsWith('/customer')) {
    // Map common routes
    if (pathname === '/' || pathname === '') {
      window.location.pathname = '/customer'
    } else if (pathname === '/login' || pathname === '/signin') {
      window.location.pathname = '/customer/login'
    } else if (pathname === '/register' || pathname === '/signup') {
      window.location.pathname = '/customer/register'
    } else if (pathname === '/dashboard') {
      window.location.pathname = '/customer/dashboard'
    }
  }
  
  // If on main domain but trying to access customer routes, redirect to login
  // Exception: Allow customer routes on localhost for development
  if (!isLocalhost && !isCustomerSubdomain && pathname.startsWith('/customer')) {
    // Allow landing page for demo
    if (pathname !== '/customer' && pathname !== '/customer/') {
      window.location.pathname = '/login'
    }
  }
}

// Get organization ID based on subdomain (deprecated - use useOrganizationFromDomain hook instead)
export const getOrganizationFromSubdomain = () => {
  const hostname = window.location.hostname

  // Check custom domains first
  const domainOrgId = getOrgIdByDomain(hostname)
  if (domainOrgId) return domainOrgId

  // Extract subdomain
  const parts = hostname.split('.')
  if (parts.length >= 2) {
    const subdomain = parts[0]
    const subdomainOrgId = getOrgIdBySubdomain(subdomain)
    if (subdomainOrgId) return subdomainOrgId
  }

  // Default for localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')) {
    return KNOWN_ORGS.DEFAULT
  }

  return null
}